//export const SERVER_URL = 'http://ec2-52-14-178-251.us-east-2.compute.amazonaws.com:9090';
let CryptoJS = require("crypto-js");

let ciphertext = CryptoJS.AES.encrypt(JSON.stringify("ABCD"), 'my-secret-key@123').toString();

console.log(ciphertext);

let backendHost;

const hostname = window && window.location && window.location.hostname;
// const port = "8081"; //My Local
// const port = "443"; //Production
// const port = "80"; //Production
var sLocation = window.location + "";
var idx = sLocation.indexOf("://");
let port = 8081;
const protocol = sLocation.substring(0, idx + 3);

if (protocol === 'https://'){
  port = '443';
} else {
  if (hostname.indexOf('localhost') >= 0){
    port = '8081';
  } else if (hostname.indexOf('xuong36thanhthai.ddns.net') >= 0){
    port = '9091';
  } else if (hostname.indexOf('115.79.140.141') >= 0){
    port = '9091';
  } else if (hostname.indexOf('192.168.1.253') >= 0){
    port = '9091';
  } else {
    port = '9090';
  }
  // port = '8888';
}

backendHost = protocol + hostname;
if (port.length > 0 && port !== '80'){
  backendHost = backendHost + ":" + port;
}

export const SELECTED_PROTOCOL = protocol;
export const PORT_IN_USED = `${port}`;
export const SERVER_URL = `${backendHost}`;
export const AUTH_API_URL = `${SERVER_URL}/wom/auth/token`;
export const API_URL = `${SERVER_URL}/wom/api/v1`;

export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_HOANTHANH = "ROLE_HOANTHANH";
export const ROLE_USER = "ROLE_USER";
export const ROLE_DESIGNER = "ROLE_DESIGNER";
export const ROLE_WORKER = "ROLE_WORKER";
export const ROLE_SERVICE = "ROLE_SERVICE";
export const ROLE_DELIVERY = "ROLE_DELIVERY";
export const ROLE_QUALITY = "ROLE_QUALITY";
export const ROLE_KHAC = "ROLE_KHAC";
export const ROLE_NHAM = "ROLE_NHAM";
export const ROLE_KIM = "ROLE_KIM";
export const ROLE_BONG = "ROLE_BONG";
export const ROLE_XI = "ROLE_XI";
export const ROLE_SHIPPING = "ROLE_SHIPPING";
export const ROLE_SHIPPING_D = "ROLE_SHIPPING_D";
export const ROLE_SUPERVISOR = "ROLE_SUPERVISOR";

export const SELECTED_ORDER_ID = 'selectedOrderId';
export const SELECTED_ORDER_IDX = 'selectedOrderIdx';
export const SELECTED_ORDER_PAGE = 'selected_order_page';
export const SELECTED_ORDER_NO = 'selectedOrderNo';

export const DATA_TYPE_PRODUCT = 1
export const DATA_TYPE_CHANGE = 2
export const DATA_TYPE_DESIGN = 3
export const DATA_TYPE_SHIPPING = 5
export const DATA_TYPE_MASTER_ITEM = 6
export const DATA_TYPE_CK = 7
export const DATA_TYPE_SUPERVISOR = 8
export const DATA_TYPE_PRINT_TAIL = 9

export const WO_DESIGN_APPROVED = 50
export const WO_ADMIN_APPROVED = 56

export const WO_NOT_READY = -58
export const WO_NOT_ADMIN_APPROVED = -56

export const WO_EXPORTED_CK = 37
export const WO_ASSIGNED_WORKER = 55
export const WO_READY = 58
export const WO_COMPLETED_CK = 38
export const WO_PRINT_TAIL = 36
export const WO_CAT = 39
export const WO_NHAM = 40
export const WO_BONG = 41
export const WO_QUAYKIM = 42
export const WO_XI = 43
export const WO_VOBAO = 44
export const WO_SHIP_FROMVN = 45
export const WO_SHIP_FROMUS = 46
export const WO_SHIP_FROMAU = 52
export const WO_TOBE_FIXED = 54
export const WO_HOANTHANH = 60

//This is for request order with item classification
export const ITEM_TYPE_LEN = 1;
export const ITEM_TYPE_DA = 3;
export const ITEM_TYPE_NORMAL = 2;
export const ITEM_TYPE_ALL = 0;
export const ITEM_TYPE_LENDA = 4

	
//This is the type of item
export const ITEM_TYPE_NONE = 0;
export const ITEM_TYPE_LEN_KHONG = 1;
export const ITEM_TYPE_LEN_DA = 2;
export const ITEM_TYPE_DA_KHONG = 3;
export const ITEM_TYPE_DA_INOX = 4;
export const ITEM_TYPE_LEN_INOX = 5;



export const STATUS_NAME_DA = "Da";
export const STATUS_NAME_LEN = "Len";

export const STATUS_DA_MOI = 0;
export const STATUS_DA_HOAN_THANH = 3;
export const STATUS_SS_SX_DA = 2;
export const STATUS_DA_DA_SX = 9;

export const STATUS_LEN_MOI = 0;
export const STATUS_LEN_HOAN_THANH = 7;
export const STATUS_SS_SX_LEN = 5;
export const STATUS_LEN_DA_SX = 11;

//export const WO_TOBE_FIXE_LOIXI = 9
export const WO_TOBE_FIXE_LOI_CATKHAC = 15
export const WO_TOBE_FIXE_LOIXI = 912
export const WO_TOBE_FIXE_LOITHO = 540
export const WO_TOBE_FIXE_ALL = 5454

export const WO_DA_SHIP = 1
export const WO_CHUA_SHIP = 2

export const WO_KIEMTRA = 53

export const WO_DESIGN = 32
export const WO_CHANGE_DESIGN = 34
export const WO_DESIGN_COMPLETE = 35
export const WO_CANCELLED = 47
export const WO_WAIT_FOR_INFO = 30

export const SELECTED_WORKORDER_IDX = 'selectedWorkOrderIdx';
export const SELECTED_QR_IDX = 'selectedQualityReportIdx';

export const LOI_THO_LIST = ['3','4','6','8','10','11','13','E005_1','E006_1','E006_2','E006_3','E006_4','E007_1','E008_1','E008_2','E008_3','E008_4','E008_5','E008_6','E008_7'];
export const LOI_XI_LIST = ['9','12', '14', 'E003_1','E009_1','E009_2'];
export const LOI_CAT_KHAC_LIST = ['1','5','E001_1','E001_2','E001_3','E001_4','E001_5','E001_6'];

export const WORK_ORDER_PRINT_WIDTH = 320;

export const IMAGE_TYPE_FRONT = 1;
export const IMAGE_TYPE_BACK = 2;

export const BLANK_IMG = 'iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAIAAAA7y9DJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAUSURBVChTY/hPCIyqQAX0UPH/PwBoboqE6s/9wgAAAABJRU5ErkJggg==';

export const WORK_ORDER_PRINT_BARCODE_WIDTH = 180;
export const WORK_ORDER_PRINT_CARDNO_WIDTH = 40;
export const WORK_ORDER_PRINT_DATE_WIDTH = 100;
export const WORK_ORDER_BARCODE_WIDTH = 1;
export const WORK_ORDER_BARCODE_HEIGHT = 25;

export const WORK_ORDER_PRINT_HEIGHT = 240;
export const WORK_ORDER_PRINT_IMAGE_HEIGHT = 50;
export const WORK_ORDER_PRINT_IMAGE_WIDTH = 120;
export const WORK_ORDER_PRINT_IMAGE_LABLE_WIDTH = 40;
export const COLOR_RANGE = "#789b73,#607c8e,#137e6d,#0f9b8e,#85a3b2," +
  "#017a79,#c8fd3d,#86a17d,#bbf90f,#5729ce,#5a06ef,#fac205,#758da3,#db4bda,#ef1de7,#ff69af,#fe83cc," + 
  "#76ff7b,#033500,#fffcc4,#fe420f,#647d8e,#ffffd4," + 
  "#77a1b5,#06b48b,#01c08d,#fd411e,#23c48b,#c9ff27,#b5ce08,#632de9,#5d21d0,#e03fd8,#d725de," + 
  "#ff69af,#95d0fc,#7bc8f6,#fe83cc,#00035b,#030764,#6b8ba4,#f9bc08,#c9643b,#c0fb2d,#96f97b,#054907,#ca6641";

export const MATERIAL_STOCK_STATUS_NEW = 0;
export const MATERIAL_STOCK_STATUS_DELIVERING = 99;
export const MATERIAL_STOCK_STATUS_DELIVERED = 1;
export const MATERIAL_STOCK_STATUS_CHANGING = 2;
export const MATERIAL_STOCK_STATUS_IN_USED = 3;
export const MATERIAL_STOCK_STATUS_EMPTY = 4;
export const MATERIAL_STOCK_STATUS_DELETED = 5;

export const MATERIAL_STATUS_NEW = 0;
export const MATERIAL_STATUS_CHANGING = 1;
export const MATERIAL_STATUS_CHANGED = 2;
export const MATERIAL_STATUS_IN_USED = 3;
export const MATERIAL_STATUS_EMPTY = 4;
export const MATERIAL_STATUS_DELETED = 5;

export const MATERIAL_COLOR_BAC = 'bac';
export const MATERIAL_COLOR_VANG = 'vang';
export const MATERIAL_COLOR_HONG = 'hong'; 

export const SELECTED_MATERIAL_BAC = 'BAC';
export const SELECTED_MATERIAL_HONG_LAC_KE = 'HONG_LAC_KE';
export const SELECTED_MATERIAL_HONG_TRANG_TRI = 'HONG_TRANG_TRI';
export const SELECTED_MATERIAL_VANG_LAC_KE = 'VANG_LAC_KE';
export const SELECTED_MATERIAL_VANG_TRANG_TRI = 'VANG_TRANG_TRI';
export const SELECTED_MATERIAL_XI_LOI = 'XI_LOI';

export const XI_MODE_NORMAL = 1; //Xi lan dau (bac, vang, hong) 
export const XI_MODE_FIX = 2; //trang Tri lai (vang hoac hong) de fix loi

export const XI_TYPE_BAC = 0;
export const XI_TYPE_LACKE = 1;
export const XI_TYPE_TRANGTRI = 2;

export const WORKING_SHOP_KEY = 'workingShop';

// errorCodes: [
//     {id: 0, name: ''},
//     {id: 1, name: 'Cắt/Khắc sai TK', mapTo: 54},
//     {id: 2, name: 'TK sai, trả về TK', mapTo: 32},
//     {id: 3, name: 'Sai size', mapTo: 54},
//     {id: 4, name: 'Sai kỹ thuật', mapTo: 54},
//     {id: 5, name: 'Cắt khắc sai', mapTo: 54},
//     {id: 6, name: 'Bạc dộp', mapTo: 54},
//     {id: 7, name: 'Quay kim không đủ, không đều', mapTo: 54},
//     {id: 8, name: 'xước, mẻ, lỗ bề mặt', mapTo: 54},
//     {id: 9, name: 'Lỗi Xi', mapTo: 54},
//     {id: 11, name: 'Lỗi mối hàn', mapTo: 54},
//     {id: 12, name: 'Lỗi trầy khi đóng gói', mapTo: 54},
//     {id: 10, name: 'Lỗi khác', mapTo: 54},
// ]
export const ERROR_CODE_LOI_XI = 9;
export const ERROR_CODE_LOI_XI_TRAY_DONG_GOI = 12;

export const ERROR_CODE_LOI_CAT_KHAC = 5;
export const ERROR_CODE_LOI_CAT_KHAC_TK = 1;

export const ERROR_CODE_COUNT_LOI_XI = 912;
export const ERROR_CODE_COUNT_LOI_CAT_KHAC = 15;
export const ERROR_CODE_COUNT_LOI_KHAC = 10;
export const DHL_NOTE_PREFIX = "DHL_NOTE_";
export const SIMPLE_PLAN_NUMOFDAY = 7;

export const ERROR_MAPPING_TYPE_THO = "T";
export const ERROR_MAPPING_TYPE_XI = "X";
export const ERROR_MAPPING_TYPE_KHAC = "K";
export const ERROR_MAPPING_TYPE_OTHER = "O";

export const ERROR_MAPPING_TYPE_THO_DESC = "Lỗi thợ";
export const ERROR_MAPPING_TYPE_XI_DESC = "Lỗi Xi";
export const ERROR_MAPPING_TYPE_KHAC_DESC = "Lỗi cắt khắc";
export const ERROR_MAPPING_TYPE_OTHER_DESC = "Lỗi khác";

export const EVENT_NAME_UPDATE_WO_DETAILS = "UPDATE_WO_DETAILS";
export const EVENT_NAME_CHANGE_WO_STATUS = "CHANGE_WO_STATUS";
export const EVENT_NAME_CHANGE_WO_SHIP_NOTE = "CHANGE_WO_SHIP_NOTE";
export const EVENT_NAME_CHANGE_WO_SHIP_CODE = "CHANGE_WO_SHIP_CODE";
export const EVENT_NAME_REPORT_WO_KIM = "REPORT_WO_KIM";

export const SEVERITY_URGENT = 2;